import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image as early as possible (LCP element)
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/3mWYQm37APitSoyXGDUGuq/ngchjgj.png';
document.head.appendChild(preloadImg);
// Render FIRST — everything else is secondary
render(<App data-id="element-460" />, document.getElementById('root'));
// Load Montserrat AFTER first paint (non-blocking)
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=optional';
    document.head.appendChild(fontLink);
  });
});